import React from 'react';
import '../css/WhyUs.css';

const WhyUs = () => {
  return (
    <div className="why-us">
      <h2>Why Us</h2>
      <ul>
        <li>Rajasthan state is known as the center of tourism industry in India and so there are plenty of employment opportunities for tourism professionals </li>
        <li>24×7 Wi-Fi and CCTV driven system in the campus. </li>
        <li>It possesses excellent infrastructure, spacious and well equipped classrooms, laboratories, experienced and competent faculties and administration. 
</li>
        <li>Mentorship and teacher-guardian programs for holistic development.</li>
        <li>Highly qualified faculties with both academic and industry exposure.</li>
        <li>Through its rigorous real-time hospitality training, it develops highest quality of practical and theoretical experience among the students, so that they can fit easily in their field of their choice. 
</li>
        <li>A formal system of pastoral care, mentorship and counselling programme has been established in the campus. In this teacher-guardian scheme, each faculty is allotted 15-20 students for counselling related to curricular and extracurricular guidance throughout the programme. 
</li>
        <li>Well-qualified and experienced faculties: Possesses potent, powerful and updated blend of academic experience and industry exposure and they apply the latest teaching-techniques and adhere extensive use of modern technology. Most are members of professional bodies and advisors at various academic forums. 
</li>
        <li>The Institute encourages new innovations and ideas through various modes of learning to cater multi cultural and multi lingual society. 
</li>
        <li>Hands-on experience in all departments of hospitality, like Cuisine, Restaurant Services, Housekeeping, Front Office Management and other facets gives SIHM, Jodhpur’s students a clear winning edge. 
</li>
        <li>Special attention is provided on one to one grooming and personality development through different development programs and practices. 
</li>
        <li>The Institute constitutes a separate cell to follow utmost safe procedures regarding safety, security, health, hygiene and sanitation as laid down by the Government. 
</li>
        <li>The Institute has a reputation of 100% placement assistance and its alumni occupy good position in the industry. The Institute strives to inculcate discipline of the highest order which is pre-requisite for hospitality industry. 
</li>
        <li>Industrial Tie-ups with the leaders in the hospitality, Tourism industry and others makes us the first choice for aspiring students. 
</li>
        <li>A separate monitoring cell has been developed to protect and prevent sexual harassment and ragging at the institution. 
</li>
        <li>Fee as prescribed by NCHMCT and Board of Governors of the Institute. 
</li>
        <li>Separate batch for Vegetarian available in Food Production Diploma Course. </li> 
      </ul>
    </div>
  );
};

export default WhyUs;